import { API_CODE } from "../../../controller/api/constants"
import { getApi, postApi, uploadApi } from "../../../controller/api/get"

export const getList = async (cookie) => {
  const response = await getApi(cookie, API_CODE.GET_BANNER_GROUP, {})

  if (response) {
    return {
      list: response,
      total: response.length,
      totalPage: 1
    }
  }
  return undefined
}

export const update = async (cookie, id, action, data) => {
  const requestData = {
    id: id,
    action: action,
    data: data
  }

  const response = await postApi(cookie, API_CODE.POST_UPDATE_BANNER_GROUP, requestData)

  return response
}

export const add = async (cookie, title, subTitle) => {
  const requestData = {
    title: title,
    subTitle: subTitle,
  }
  const response = await postApi(cookie, API_CODE.POST_ADD_BANNER_GROUP, requestData)

  return response
}